const initialState = {
  cache: JSON.parse(localStorage.getItem('dataCache')) ? JSON.parse(localStorage.getItem('dataCache')) : {},
  activeDataSet: {
    boiRanges: [],
    pmmQuestionnaireRanges: {
      policy: [],
      practice: [],
      platform: [],
    },
    pmmmPrioritizationGrid: [],
    regionalComparisonData: [],
    regionalComparsionCrossIndustry: {},
    regionalComparsionSameIndustry: {},
    boiRangesChecked: [],
    leadRanges: [],
  },
  activeRegionalComparison: {
    policy: [],
    practice: [],
    platform: [],
    regions: [],
  },
};


const dataSetReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_DATA_SET':
    return Object.assign({}, state, {
      cache: action.payload.cache,
      activeDataSet: action.payload.activeDataSet,
      activeRegionalComparison: action.payload.activeRegionalComparison,
    });
  case 'SET_LI_DATA':
    return Object.assign({}, state, {
      cache: action.payload.cache,
      activeDataSet: action.payload.activeDataSet,
    });
  case 'UPDATE_FOUR_STEP_RANGES':
    return Object.assign({}, state, {
      cache: action.payload.cache,
      activeDataSet: action.payload.activeDataSet,
      activeRegionalComparison: action.payload.activeRegionalComparison,
    });
  case 'CHANGE_BOI_CHECKED_ARRAY':
    return Object.assign({}, state, {
      cache: action.payload.cache,
      activeDataSet: action.payload.activeDataSet,
    });
  case 'UPDATE_BOI_LI_VALUE':
    return Object.assign({}, state, {
      cache: action.payload.cache,
      activeDataSet: action.payload.activeDataSet,
    });
  case 'RESET_DATA_SETS':
    return Object.assign({}, state, {
      cache: {},
      activeDataSet: {
        boiRanges: [],
        pmmQuestionnaireRanges: {
          policy: [],
          practice: [],
          platform: [],
        },
        pmmmPrioritizationGrid: [],
        regionalComparisonData: [],
        regionalComparsionCrossIndustry: {},
        regionalComparsionSameIndustry: {},
        boiRangesChecked: [],
        leadRanges: [],
      },
      activeRegionalComparison: {
        policy: [],
        practice: [],
        platform: [],
        regions: [],
      },
    });
  default:
    return state;
  }
};


export default dataSetReducer;
